module.exports = __webpack_public_path__ + "static/13-5220fc7ade28d9b502de80cdf9af529a.png";